import { createGlobalStyle } from "styled-components";

import { colors, fonts, media } from "@src/packages/chime-ui/system";

export const GlobalStyle = createGlobalStyle`
@font-face {
  font-family: 'Circular Pro';
  font-style: normal;
  font-weight: 500;
  font-display: fallback;
  src: url('/identity/fonts/lineto-circular-pro-book.eot'); /* IE9 Compat Modes */
  src: local('Circular Pro Book'), local('CircularPro-Book'),
    url('/identity/fonts/lineto-circular-pro-book.eot?#iefix') format('embedded-opentype'),
    /* IE6-IE8 */ url('/identity/fonts/lineto-circular-pro-book.woff2') format('woff2'),
    /* Super Modern Browsers */ url('/identity/fonts/lineto-circular-pro-book.woff')
      format('woff'); /* Modern Browsers */
}
@font-face {
  font-family: 'Circular Pro';
  font-style: normal;
  font-weight: 700;
  font-display: fallback;
  src: url('/identity/fonts/lineto-circular-pro-bold.eot'); /* IE9 Compat Modes */
  src: local('Circular Pro Bold'), local('CircularPro-Bold'),
  url('/identity/fonts/lineto-circular-pro-bold.eot?#iefix') format('embedded-opentype'),
  /* IE6-IE8 */ url('/identity/fonts/lineto-circular-pro-bold.woff2') format('woff2'),
  /* Super Modern Browsers */ url('/identity/fonts/lineto-circular-pro-bold.woff')
    format('woff'); /* Modern Browsers */
}
body{
  font-family: ${fonts.primary};
  color: ${colors.notBlack};
  background-color: ${colors.white};
  min-height: 100%;
  height: auto;
  ${media.tablet`
    background-color: ${colors.alabaster};
  `};
}`;
